import { UnrealIcon } from './UnrealIcon';

/**
 * author: Contributors
 * id 4AC79EF3-5BCA-41EC-976E-CB821416A905
 * name unreal
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unreal.svg
 * tags
 * - Brand / Logo 
 * - Gaming / RPG 
 */
export const UnrealEngineIcon = UnrealIcon;
export default UnrealEngineIcon